import { useState } from "react";

import { RenderSeeMoreTextAnswers } from "~/common/components";
import { INTAKE_QUESTION_CODES, YES_NO_NA_TYPES } from "~/common/utils";
import AudioPlayer from "~/patients/components/ui/AudioPlayer";
import { YesNoNaWithAudioResponse } from "~/providers/utils/types/rawResponsesTypes";

interface YesNoNaWithAudioAnswerProps {
  answers: YesNoNaWithAudioResponse[];
  questionCode: string;
}

export const YesNoNaWithAudioAnswer = ({
  answers,
  questionCode,
}: YesNoNaWithAudioAnswerProps) => {
  const [seeMoreActive, setSeeMoreActive] = useState(false);

  const onClickSeeMoreButton = () => {
    setSeeMoreActive((prev) => !prev);
  };

  const formatAnswer = (answer: YesNoNaWithAudioResponse) => {
    if (
      questionCode === INTAKE_QUESTION_CODES.cut_down_alcohol_use &&
      answer.value === YES_NO_NA_TYPES.na
    ) {
      return "No alcohol use";
    }
    return answer.value;
  };

  return answers.map((answer, index) => (
    <div className="flex flex-col gap-2 py-4" key={`${questionCode}-${index}`}>
      {answer.value && (
        <span className="first-letter:capitalize">{formatAnswer(answer)}</span>
      )}
      {answer.audio && (
        <>
          <AudioPlayer
            thumbNailClassName="blue-thumb bg-primary-200"
            totalDuration={answer.audio.duration ?? 0}
            src={answer.audio.path}
            className="w-full border border-primary-200 bg-primary-100 p-2 text-primary-600"
            iconsClassName="text-primary-600"
          />
          {answer.audio.transcribed_text && (
            <RenderSeeMoreTextAnswers
              seeMoreActive={seeMoreActive}
              onClick={onClickSeeMoreButton}
              text={answer.audio.transcribed_text}
              shortTextClassName="break-words text-sm font-light text-gray-10"
              longTextClassName="text-sm font-light text-gray-10"
            />
          )}
        </>
      )}
    </div>
  ));
};
